import { render } from "./DocumentsOverview.vue?vue&type=template&id=1196c21c"
import script from "./DocumentsOverview.vue?vue&type=script&lang=js"
export * from "./DocumentsOverview.vue?vue&type=script&lang=js"
script.render = render

export default script